import { __decorate } from "tslib";
import { LitElement, css, html, property, customElement } from 'lit-element';
import '@cds/core/internal-components/close-button/register.js';
import { baseStyles } from './styles';
import { getTabableItems } from './utils';
let CdsGridDetail = class CdsGridDetail extends LitElement {
    constructor() {
        super(...arguments);
        this.slot = 'detail';
        this.hidden = false;
        this.anchor = '';
    }
    static get styles() {
        return [baseStyles, css `
      :host {
        display: contents;
      }

      dialog {
        background: var(--cds-alias-object-container-background);
        z-index: 999;
        border: 0;
        box-shadow: var(--cds-alias-object-shadow-100);
        color: var(--cds-global-typography-color-500);
        padding: 0;
        margin: 0;
        display: block;
        width: 66%;
        height: 100%;
        right: 0;
        top: 0;
        bottom: 0;
        left: auto;
        position: absolute;
        padding: var(--cds-global-space-9);
      }

      dialog::backdrop {
        background: transparent;
      }

      cds-inline-button {
        position: absolute;
        top: var(--cds-global-space-6);
        right: var(--cds-global-space-6);
        --color: var(--cds-global-typography-color-500);
      }

      .private-host {
        position: relative;
      }
    `];
    }
    get dialog() {
        return this.shadowRoot.querySelector('dialog');
    }
    render() {
        return html `  
      <dialog>
        <slot></slot>
        <!-- cds-internal-close-button has a severe re-calc performance bug -->
        <cds-inline-button @click=${this.close} aria-label="close row details">
          <cds-icon shape="times"></cds-icon>
        </cds-inline-button>
      </dialog>
    `;
    }
    firstUpdated(props) {
        super.firstUpdated(props);
        this.dialog.addEventListener('close', () => {
            if (!this.hidden) {
                this.close();
            }
        });
        this.getRootNode().addEventListener('keydown', (e) => {
            if (e.code === 'Escape') {
                e.preventDefault();
                this.close();
            }
        });
    }
    updated(props) {
        super.updated(props);
        if (props.has('hidden') && props.get('hidden') !== undefined && props.get('hidden') !== this.hidden) {
            if (this.hidden) {
                this.dialog.close();
            }
            else {
                const focusableItem = getTabableItems(this)[0];
                if (focusableItem) {
                    focusableItem.focus();
                }
                else {
                    const firstElement = this.querySelector('*');
                    firstElement.setAttribute('tabindex', '0');
                    firstElement.focus();
                }
            }
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.close();
    }
    close() {
        var _a;
        this.dispatchEvent(new CustomEvent('closeChange'));
        (_a = this.getRootNode().querySelector(`#${this.anchor}`)) === null || _a === void 0 ? void 0 : _a.focus();
    }
};
__decorate([
    property({ type: String, reflect: true })
], CdsGridDetail.prototype, "slot", void 0);
__decorate([
    property({ type: Boolean })
], CdsGridDetail.prototype, "hidden", void 0);
__decorate([
    property({ type: String })
], CdsGridDetail.prototype, "anchor", void 0);
CdsGridDetail = __decorate([
    customElement('cds-grid-detail')
], CdsGridDetail);
export { CdsGridDetail };
//# sourceMappingURL=grid-detail.element.js.map